var map = {
	"./CallResultMailer/manifest.json": "phQq",
	"./Callcenter/manifest.json": "+2fb",
	"./Calls/manifest.json": "KITr",
	"./Campaigns/manifest.json": "Ka5X",
	"./CustomerChat/manifest.json": "ViU1",
	"./Dialer/manifest.json": "Kb/S",
	"./DoNotCall/manifest.json": "Bo3s",
	"./Events/manifest.json": "hhBg",
	"./FacebookChat/manifest.json": "uG3g",
	"./GsmTrackers/manifest.json": "Zi6f",
	"./Mails/manifest.json": "gIR+",
	"./Menu/manifest.json": "65yI",
	"./Notifications/manifest.json": "hVKO",
	"./Pauses/manifest.json": "cb9j",
	"./Phonebook/manifest.json": "RVpC",
	"./Player/manifest.json": "XRJk",
	"./Polls/manifest.json": "/8OT",
	"./Queues/manifest.json": "crEm",
	"./Reporting/manifest.json": "eY2k",
	"./Settings/manifest.json": "IfKf",
	"./Sms/manifest.json": "b+/l",
	"./Ticketing/manifest.json": "M9ml",
	"./User/manifest.json": "uYnG",
	"./Voicemails/manifest.json": "cKUA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YtIH";